import { frontendURL } from '../../../dashboard/helper/URLHelper';

const WhatsappCampaigns = () => import('./Index.vue');

export default [
  {
    path: frontendURL('accounts/:accountId/campaigns/online_wa_mass'),
    name: 'online_wa_mass',
    roles: ['administrator'],
    component: WhatsappCampaigns,
  },
];
